<template>
    <div class="animated fadeIn">

                <div v-if="Core.Product.conditionalIsEnabled(dataProduct)">
                    <b-row>
                        <b-col lg="6">
                            <div v-if="Core.Value.encode(dataProduct.conditionalForceSeasonId, 'checkbox')">
                                <InputSelect
                                        :search="false"
                                        :label="Core.Definition.getDefinition('Veuillez sélectionner une saison')"
                                        :options="dataSelectOptions.conditionalSeasonId"
                                        v-model="dataProduct.conditional.seasonId"></InputSelect>
                            </div>
                            <div v-if="Core.Value.encode(dataProduct.conditionalForceLeagueId, 'checkbox')">
                                <InputSelect
                                        :search="false"
                                        :label="Core.Definition.getDefinition('Veuillez sélectionner une ligue')"
                                        :options="dataSelectOptions.conditionalLeagueId"
                                        v-model="dataProduct.conditional.leagueId"></InputSelect>
                            </div>
                            <div v-if="Core.Value.encode(dataProduct.conditionalForceDistrictId, 'checkbox')">
                                <InputSelect
                                        :search="false"
                                        :label="Core.Definition.getDefinition('Veuillez sélectionner une région')"
                                        :options="dataSelectOptions.conditionalDistrictId"
                                        v-model="dataProduct.conditional.districtId"></InputSelect>
                            </div>
                            <div v-if="dataProduct.conditional.eventDateId!==null && filterCompleted(dataProduct)" :key="dataProduct.id + '-' + conditionalEventDateIndex" v-for="conditionalEventDate, conditionalEventDateIndex in dataProduct.conditional.eventDateId">
                                <b-button @click="onSelectEventDateClick(dataProduct.id, conditionalEventDateIndex)" class="btn btn-sm m-1" :class="{'btn-light' : !Core.Validation.isId(conditionalEventDate.id), 'btn-success' : Core.Validation.isId(conditionalEventDate.id)}">
                                                <span v-if="!Core.Validation.isId(conditionalEventDate.id)">
                                                    {{Core.Text.format(Core.Definition.getDefinition('Sélectionnez un événement #{0}'), conditionalEventDateIndex + 1)}}
                                                </span>
                                    <span v-if="Core.Validation.isId(conditionalEventDate.id)">
                                                    {{ Core.Date.readableDate(conditionalEventDate.start) }} - {{conditionalEventDate.title}}
                                                </span>
                                </b-button>
                            </div>
                            <b-alert v-if="dataProduct.verbal!==''" show variant="light">
                                {{dataProduct.verbal}}
                            </b-alert>
                        </b-col>
                    </b-row>

                </div>

                <div class="mt-4" v-if="Core.Product.participantModeIsEnabled(dataProduct)">
                    <b-row class="mb-3">
                        <b-col>
                            <strong>{{Core.Definition.getDefinition('Complétez les informations du participant')}}</strong>
                        </b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col>
                            <b-button @click="onSelectParticipantClick(dataProduct.id)" class="btn btn-sm m-1 btn-light">
                                {{Core.Definition.getDefinition('Sélectionner un participant existant')}}
                            </b-button>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col lg="4">
                            <InputText
                                    :label="Core.Definition.getDefinition('Prénom')"
                                    v-model="dataProduct.participant.firstname">
                            </InputText>
                        </b-col>
                        <b-col lg="4">
                            <InputText
                                    :label="Core.Definition.getDefinition('Nom')"
                                    v-model="dataProduct.participant.lastname">
                            </InputText>
                        </b-col>
                        <b-col lg="4">
                            <InputDatePicker
                                    :label="Core.Definition.getDefinition('Date de naissance')"
                                    v-model="dataProduct.participant.birthdate">
                            </InputDatePicker>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col lg="4">
                            <InputText
                                    :label="Core.Definition.getDefinition('Urgence: Contact')"
                                    v-model="dataProduct.participant.urgencyContact">
                            </InputText>
                        </b-col>
                        <b-col lg="4">
                            <InputPhone
                                    :label="Core.Definition.getDefinition('Urgence: Téléphone')"
                                    v-model="dataProduct.participant.urgencyPhone">
                            </InputPhone>
                        </b-col>
                        <b-col lg="4">
                            <InputText
                                    :label="Core.Definition.getDefinition('Num. assurance maladie')"
                                    v-model="dataProduct.participant.insuranceNumber">
                            </InputText>
                        </b-col>
                    </b-row>

                    <b-row v-if="Core.Value.encode(dataProduct.teamIsEnabled, 'checkbox') || Core.Value.encode(dataProduct.participantCategoryIsEnabled, 'checkbox')">
                        <b-col lg="6" v-if="Core.Value.encode(dataProduct.teamIsEnabled, 'checkbox')">
                            <InputSelect
                                    :search="false"
                                    :label="Core.Definition.getDefinition('Équipe')"
                                    :options="getTeamOptions(dataProduct)"
                                    @onSelect="onSelectTeam(dataProduct.id)"
                                    v-model="dataProduct.participant.teamId">
                            </InputSelect>
                            <InputText
                                    :_isVisible="false"
                                    :ref="'newTeam' + dataProduct.id"
                                    :label="Core.Definition.getDefinition('Nouvelle équipe')"
                                    :description="Core.Definition.getDefinition('Le nom de votre équipe peut être sujet à une vérification.')"
                                    v-model="dataProduct.participant.teamTitle">
                            </InputText>
                        </b-col>
                        <b-col lg="6" v-show="Core.Value.encode(dataProduct.participantCategoryIsEnabled, 'checkbox')">
                            <InputSelect
                                    :search="false"
                                    :label="Core.Definition.getDefinition('Catégorie')"
                                    :options="getParticipantCategoryOptions(dataProduct)"
                                    v-model="dataProduct.participant.participantCategoryId">
                            </InputSelect>
                        </b-col>
                    </b-row>

                    <b-row v-if="Core.Value.encode(dataProduct.tshirtSizeIsEnabled, 'checkbox')">
                        <b-col lg="6">
                            <InputSelect
                                    :search="false"
                                    :label="Core.Definition.getDefinition('T-Shirt: Taille')"
                                    :options="getTshirtSizeOptions(dataProduct)"
                                    v-model="dataProduct.participant.tshirtSize">
                            </InputSelect>
                        </b-col>
                        <b-col lg="6">
                            <InputText
                                    v-if="Core.Value.encode(dataProduct.tshirtCustomNameIsEnabled, 'checkbox')"
                                    :label="Core.Definition.getDefinition('T-Shirt: Nom personnalisé')"
                                    v-model="dataProduct.participant.tshirtCustomName">
                            </InputText>
                        </b-col>
                    </b-row>

                </div>

                <template v-if="dataFormTemplates.length > 0">
                    <b-row v-for="formTemplate, formTemplateIndex in dataFormTemplates" v-if="formTemplate.productId === dataProduct.id">
                        <b-col>
                            <CForm :ref="'integratedForm' + formTemplate.formTemplateId" :structure="formTemplate.structure"></CForm>
                        </b-col>
                    </b-row>
                </template>

                <ModalInstanceSelector
                        :caption="Core.Definition.getDefinition('Choix de l\'événement')"
                        ref="modalInstanceSelectorEventDate"
                        root="/event-date/list"
                        v-model="dataEventDates"
                        @onAdd="onAddEventDate"
                        :multiple="false"
                        :searchArgs="[
                                        {
                                            key: 'seasonId',
                                            value: filterSeasonId(dataProduct),
                                            compare: 'IN'
                                        },
                                        {
                                            key: 'leagueId',
                                            value: filterLeagueId(dataProduct),
                                            compare: 'IN'
                                        },
                                        {
                                            key: 'districtId',
                                            value: filterDistrictId(dataProduct),
                                            compare: 'IN'
                                        },
                                        {
                                            key: 'start',
                                            value:  Vue.moment().format('YYYY-MM-DD'),
                                            compare: '>'
                                        }
                                ]"
                        :searchFormStructure="{
                                      rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'start'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                     ],
                                     fields: [
                                            {
                                                id: 'start',
                                                type: 'datePicker',
                                                isInline: false,
                                                label: Core.Definition.getDefinition('Date'),
                                                value: null,
                                                onChange: function() {}
                                            }
                                      ]
                                 }"
                        :options="{
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucune date à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                 }"
                        :columns="[
                                {
                                    label: Core.Definition.getDefinition('Date'),
                                    key: 'start',
                                    type: 'date',
                                    format: 'DD MMM YYYY HH:mm',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>

                <ModalInstanceSelector
                        :caption="Core.Definition.getDefinition('Participants')"
                        ref="modalInstanceSelectorParticipant"
                        root="/participant/list"
                        v-model="dataParticipants"
                        @onAdd="onAddParticipant"
                        :multiple="false"
                        :searchArgs="[
                                        {
                                            key: 'parentId',
                                            value: Core.Session.AuthUser.id,
                                        }
                                ]"
                        :options="{
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucun participant existant'),
                                        borderVariant: 'white',
                                        noBody: true
                                 }"
                        :columns="[
                                {
                                    label: Core.Definition.getDefinition('Prénom'),
                                    key: 'firstname',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Nom de famille'),
                                    key: 'lastname',
                                    sortable: true
                                }]">
                </ModalInstanceSelector>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import InputSelect from './InputSelect'
    import InputText from './InputText'
    import InputPhone from './InputPhone'
    import InputDatePicker from './InputDatePicker'
    import InstanceSelector from './InstanceSelector'
    import Request from './Request'
    import ModalInstanceSelector from './ModalInstanceSelector'
    import CForm from './CForm'
    export default {
        name: 'ProductOption',
        components: {
            InputSelect,
            InputText,
            InputDatePicker,
            InstanceSelector,
            Request,
            ModalInstanceSelector,
            InputPhone,
            CForm
        },
        props: {
            value: {
                type: Object,
                default: function() {
                    return {}
                }
            },
            selectOptions: {
                type: Object,
                default: function() {
                    return {}
                }
            },
            formTemplates: {
                type: Array,
                default: function() {
                    return []
                }
            }
        },
        computed: {
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataProduct(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.dataProduct = this.value
            this.dataSelectOptions = this.selectOptions
            this.dataFormTemplates = this.formTemplates
        },
        data: function () {
            return {
                Core: window.Core,
                dataProduct: {},
                dataFormTemplates: [],
                dataEventDates: [],
                dataParticipants: [],
                dataSelectOptions: {
                    conditionalSeasonId: [],
                    conditionalLeagueId: [],
                    conditionalDistrictId: [],
                    teamId: [],
                    participantCategoryId: [],
                    tshirtSize: []
                },
                dataProductIndex: '',
                dataEventDateIndex: '',
                dataAlertMessage: false,
                dataVerbal: '',
                dataDisplayNewTeam: false,
                Vue: Vue
            }
        },
        methods: {
            getParticipantCategoryOptions(product) {
                let options = []
                product.participantCategoryId = Core.Value.encode(product.participantCategoryId, Core.Value.typeMultiSelect)
                if (Array.isArray(product.participantCategoryId)&&product.participantCategoryId.length > 0) {
                    for(let participantCategoryOption in this.dataSelectOptions.participantCategoryId) {
                        participantCategoryOption = this.dataSelectOptions.participantCategoryId[participantCategoryOption]
                        for(let participantCategoryId in product.participantCategoryId) {
                            participantCategoryId = product.participantCategoryId[participantCategoryId]
                            if (participantCategoryId===participantCategoryOption.value) {
                                options.push(participantCategoryOption)
                            }
                        }
                    }
                } else {
                    options = this.dataSelectOptions.participantCategoryId
                }
                return options
            },
            getTshirtSizeOptions(product) {
                let options = []
                product.tshirtSize = Core.Value.encode(product.tshirtSize, Core.Value.typeMultiSelect)
                if (Array.isArray(product.tshirtSize)&&product.tshirtSize.length > 0) {
                    for(let tshirtSizeOption in this.dataSelectOptions.tshirtSize) {
                        tshirtSizeOption = this.dataSelectOptions.tshirtSize[tshirtSizeOption]
                        for(let tshirtSize in product.tshirtSize) {
                            tshirtSize = product.tshirtSize[tshirtSize]
                            if (tshirtSize===tshirtSizeOption.value) {
                                options.push(tshirtSizeOption)
                            }
                        }
                    }
                } else {
                    options = this.dataSelectOptions.tshirtSize
                }
                return options
            },
            getTeamOptions(product) {
                let options = []
                product.teamId = Core.Value.encode(product.teamId, Core.Value.typeMultiSelect)
                if (Array.isArray(product.teamId)&&product.teamId.length > 0) {
                    for(let teamIdOption in this.dataSelectOptions.teamId) {
                        teamIdOption = this.dataSelectOptions.teamId[teamIdOption]
                        for(let teamId in product.teamId) {
                            teamId = product.teamId[teamId]
                            if (teamId===teamIdOption.value) {
                                options.push(teamIdOption)
                            }
                        }
                    }
                } else {
                    options = Core.Array.newArray(this.dataSelectOptions.teamId)
                }

                if (product.teamCreationIsEnabled) {
                    options.unshift({
                        label: Core.Definition.getDefinition('Nouvelle équipe'),
                        value: 'new'
                    })
                }
                if (product.teamlessIsEnabled) {
                    options.unshift({
                        label: Core.Definition.getDefinition('Sans équipe'),
                        value: ''
                    })
                }
                return options
            },
            filterCompleted(product) {
                if (Core.Value.encode(product.conditionalForceSeasonId, Core.Value.typeCheckbox)) {
                    if (!Core.Validation.isId(Core.Value.decode(product.conditional.seasonId, Core.Value.typeSelect))) {
                        return false
                    }
                }
                if (Core.Value.encode(product.conditionalForceLeagueId, Core.Value.typeCheckbox)) {
                    if (!Core.Validation.isId(Core.Value.decode(product.conditional.leagueId, Core.Value.typeSelect))) {
                        return false
                    }
                }
                if (Core.Value.encode(product.conditionalForceDistrictId, Core.Value.typeCheckbox)) {
                    if (!Core.Validation.isId(Core.Value.decode(product.conditional.districtId, Core.Value.typeSelect))) {
                        return false
                    }
                }
                return true
            },
            filterSeasonId(product) {
                let filter = []

                let conditionalDateConditionals = Core.Value.encode(product.conditionalDateConditionals, Core.Value.typeMultiSelect)

                if (conditionalDateConditionals.includes('season') && product.conditionalForceSeasonId) {
                    filter = Core.Value.decode(product.conditional.seasonId, Core.Value.typeSelect)
                } else {
                    if (product.conditionalDateConditionals && product.conditionalSeasonId !== '') {
                        filter = Core.Value.decode(product.conditionalSeasonId, Core.Value.typeMultiSelect)
                    }
                }
                return filter
            },
            filterLeagueId(product) {
                let filter = []

                let conditionalDateConditionals = Core.Value.encode(product.conditionalDateConditionals, Core.Value.typeMultiSelect)

                if (conditionalDateConditionals.includes('league') && product.conditionalForceLeagueId) {
                    filter = Core.Value.decode(product.conditional.leagueId, Core.Value.typeSelect)
                } else {
                    if (product.conditionalDateConditionals && product.conditionalLeagueId !== '') {
                        filter = Core.Value.decode(product.conditionalLeagueId, Core.Value.typeMultiSelect)
                    }
                }
                return filter
            },
            filterDistrictId(product) {
                let filter = []

                let conditionalDateConditionals = Core.Value.encode(product.conditionalDateConditionals, Core.Value.typeMultiSelect)

                if (conditionalDateConditionals.includes('district') && product.conditionalForceDistrictId) {
                    filter = Core.Value.decode(product.conditional.districtId, Core.Value.typeSelect)
                } else {
                    if (product.conditionalDateConditionals && product.conditionalDistrictId !== '') {
                        filter = Core.Value.decode(product.conditionalDistrictId, Core.Value.typeMultiSelect)
                    }
                }
                return filter
            },
            onSelectEventDateClick(productIndex, eventDateIndex) {
                this.dataProductIndex = productIndex
                this.dataEventDateIndex = eventDateIndex
                if (this.$refs['modalInstanceSelectorEventDate'] !== undefined) {
                    this.$refs['modalInstanceSelectorEventDate'].open = true
                }
            },
            onSelectParticipantClick(productIndex) {
                this.dataProductIndex = productIndex
                if (this.$refs['modalInstanceSelectorParticipant'] !== undefined) {
                    this.$refs['modalInstanceSelectorParticipant'].open = true
                }
            },
            onAddEventDate(row, data) {
                this.dataProduct.conditional.eventDateId[this.dataEventDateIndex] = row
                this.$forceUpdate()
            },
            onAddParticipant(row, data) {
                let participant = row

                participant.tshirtSize = Core.Select.select(participant.tshirtSize, this.dataSelectOptions.tshirtSize)
                participant.teamId = Core.Select.select(participant.teamId, this.dataSelectOptions.teamId)
                participant.participantCategoryId = Core.Select.select(participant.participantCategoryId, this.dataSelectOptions.participantCategoryId)

                this.dataProduct.participant = participant
                this.$forceUpdate()
            },
            onSelectTeam(productIndex) {
                if (this.dataProduct.participant !== undefined) {
                    if (this.dataProduct.participant.teamId !== undefined) {
                        if (Core.Select.value(this.dataProduct.participant.teamId) === 'new') {
                            this.$refs['newTeam' + productIndex].isVisible = true
                            return
                        }
                    }
                }
                this.$refs['newTeam' + productIndex].isVisible = false
            }
        }
    }
</script>
